module.exports = __webpack_public_path__ + "static/img/ico_weixin_hover.b9f9538b.png";